import { i18nFilter } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

export function trackEvent(
    tableOptions: FixmeType,
    category: string,
    subname?: string,
    action?: string,
    value?: string,
) {
    if (category === "upgrade") {
        allTrackers.trackEvent("Internal Link", "click", "Hook/Table/Pricing Page");
    } else {
        let subName = subname;
        if (tableOptions && tableOptions.trackName) {
            subName = i18nFilter()(tableOptions.trackName) + "/" + subName;
        }
        // @ts-ignore FIXME: strict migration - Argument of type 'string | undefined' is not assignable to parameter of type 'string' — preserving legacy behavior where action may be undefined
        allTrackers.trackEvent(category, action, "Table/" + subName + (value ? "/" + value : ""));
    }
}
